import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FlowList from './Flow/FlowList.tsx';
import ChatbotBuilder from './ChatbotBuilder.tsx';
import ErrorPage from '../Shared/ErrorPage/index.jsx';
import ScheduleMessagesList from './ScheduleMessages/List.tsx';

const FlowRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<ErrorPage />} />
      <Route path={`/list`} element={<FlowList />} />
      <Route path={`/builder/:flowId`} element={<ChatbotBuilder />} />
      <Route path={`/schedule-messages/:flowId`} element={<ScheduleMessagesList />} />
    </Routes>
  );
};

export default FlowRoutes;
